<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M4.39339 2.40137H11.4998C11.6898 2.40137 11.8579 2.52597 11.9149 2.70801V2.70898L11.9198 2.7207L13.6698 7.16699L13.6707 7.17285C13.6848 7.22162 13.6901 7.27446 13.6854 7.33301L13.6844 7.34766L13.6854 7.3623C13.6861 7.37038 13.6864 7.38237 13.6864 7.4043V13.1221C13.6847 13.5536 13.3323 13.9053 12.9012 13.9053H3.1014L3.02425 13.9014C2.84503 13.8833 2.67619 13.8042 2.54769 13.6758C2.40092 13.529 2.31866 13.3296 2.3182 13.1221V7.4043C2.31822 7.38549 2.31952 7.36554 2.32113 7.33984L2.32211 7.32324L2.31918 7.30566C2.31552 7.27982 2.31527 7.25305 2.31722 7.22559L2.33089 7.1416V7.13965L2.33187 7.14062L2.33382 7.13281L3.97347 2.72363L3.97738 2.71289C4.03148 2.52917 4.2018 2.40148 4.39339 2.40137ZM3.18343 13.0381H12.8162V7.48828H10.0946L10.0516 7.58887C9.90843 7.92378 9.69808 8.20763 9.43343 8.42383L9.31625 8.51172C8.95174 8.76817 8.49728 8.90716 8.00179 8.90723C7.06 8.90723 6.31339 8.41815 5.96078 7.58984L5.91781 7.48828H3.18343V13.0381ZM4.67367 3.37109L3.43148 6.3916L3.33675 6.62109H6.63754L6.63949 6.70312C6.64642 7.08651 6.77685 7.42398 7.02621 7.66992C7.27638 7.91644 7.61823 8.04003 7.99984 8.04004C8.39159 8.04004 8.73328 7.90862 8.97933 7.66895C9.19458 7.4592 9.32752 7.17519 9.36214 6.84668L9.37093 6.70312L9.37289 6.62109H12.5936L12.4959 6.38965L11.2186 3.36914L11.1756 3.26758H4.71664L4.67367 3.37109Z"
      fill="#1DBF73"
      :stroke="color || '#1DBF73'"
      stroke-width="0.333333"
    />
  </svg>
</template>

<script>
export default {
  props: ["color"],
};
</script>
